import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { REPORT_TEMPLATE___APPLICATION_TYPE, StorageService } from '../_services/storage.service';
import { RtbAuthService } from './rtb-auth.service';

@Injectable({
  providedIn: 'root'
})
export class VisolAuthGuard {

  constructor(
    private storageService: StorageService,
    private router: Router,
    private rtbAuthService: RtbAuthService) {
  }

  public async canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let isViSOL = false;
    const application = state.root.queryParamMap.get('application');

    if (application === 'ViSOL') {
      isViSOL = true;
      this.storageService.pushApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE, { IsVisol: true });
    }

    const appType = this.storageService.fetchApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE);

    if (appType && appType.IsVisol) isViSOL = true;
    if (!isViSOL) return true;

    try {
      const userProfile = await this.rtbAuthService.getCurrentUserProfile();
      if (userProfile && (userProfile.role === 'Admin' || userProfile.role === 'Owner')) {
        return true
      } else {
        this.router.navigateByUrl('/access-page');
        return false
      }
    } catch (error) {
      console.error(error);
      this.router.navigateByUrl('/access-page');
      return false
    }

  }
}
